import i18n from '../i18n';
import api from '../api/publicSurveyApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  GET_PUBLIC_SURVEYS: 'GET_PUBLIC_PUBLIC_SURVEYS',
  GET_PUBLIC_SURVEYS_SUCCESS: 'GET_PUBLIC_SURVEYS_SUCCESS',
  GET_PUBLIC_SURVEYS_FAILURE: 'GET_PUBLIC_SURVEYS_FAILURE',
  GET_PUBLIC_SURVEY: 'GET_PUBLIC_SURVEY',
  GET_PUBLIC_SURVEY_SUCCESS: 'GET_PUBLIC_SURVEY_SUCCESS',
  GET_PUBLIC_SURVEY_FAILURE: 'GET_PUBLIC_SURVEY_FAILURE',
  SUBMIT_PUBLIC_SURVEY_SUCCESS: 'SUBMIT_PUBLIC_SURVEY_SUCCESS',
  SUBMIT_PUBLIC_SURVEY_FAILURE: 'SUBMIT_PUBLIC_SURVEY_FAILURE',
  DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE: 'DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE',
  DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_SUCCESS: 'DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_SUCCESS',
  DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_FAILURE: 'DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_FAILURE',
  VERIFY_SURVEY_SUBMISSION: 'VERIFY_SURVEY_SUBMISSION',
  VERIFY_SURVEY_SUBMISSION_SUCCESS: 'VERIFY_SURVEY_SUBMISSION_SUCCESS',
  VERIFY_SURVEY_SUBMISSION_FAILURE: 'VERIFY_SURVEY_SUBMISSION_FAILURE',
};

export const actions = {
  getAll: () => dispatch => {
    dispatch({ type: types.GET_PUBLIC_SURVEYS });

    return api
      .get()
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_PUBLIC_SURVEYS_SUCCESS, surveys: response.data });
        }

        dispatch({ type: types.GET_PUBLIC_SURVEYS_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.getSurveysFailure')));
        return logger.error(response);
      });
  },
  getDetails: id => dispatch => {
    dispatch({ type: types.GET_PUBLIC_SURVEY });

    return api
      .getDetails(id)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_PUBLIC_SURVEY_SUCCESS, survey: response.data });
        }

        dispatch({ type: types.GET_PUBLIC_SURVEY_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.getSurveyDetailsFailure')));
        return logger.error(response);
      });
  },
  submitSurvey: (id, data) => dispatch => {
    return api
      .submitSurvey(id, data)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess(i18n.t('surveys.actions.submitSurveySuccess')));
          dispatch({ type: types.SUBMIT_PUBLIC_SURVEY_SUCCESS, surveyForm: data.form });
          window.location.href = 'https://' + window.location.host;
          return null;
        }

        dispatch({ type: types.SUBMIT_PUBLIC_SURVEY_FAILURE });
        if (response.status === 400 && response.data && ((response.data.validationErrors && response.data.validationErrors.some(v => v.errorMessage === "Dane respondenta zostały już wykorzytane")) || response.data.type)) {
          return response;
        } else {
          dispatch(notificationActions.showError(i18n.t('surveys.actions.submitSurveyFailure')));
        }

        logger.error(response);
        return response;
      });
  },
  verifySurveySubmission: (id, submissionId) => dispatch => {
    dispatch({ type: types.VERIFY_SURVEY_SUBMISSION });
    
    return api
      .verifySurveySubmission(id, submissionId)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess(i18n.t('surveys.actions.verifySurveySubmissionSuccess')));
          dispatch({ type: types.VERIFY_SURVEY_SUBMISSION_SUCCESS });
          return null;
        }

        dispatch({ type: types.VERIFY_SURVEY_SUBMISSION_FAILURE });
        if (response.status === 400 && response.data) {
          return response;
        } else {
          dispatch(notificationActions.showError(i18n.t('surveys.actions.verifySurveySubmissionFailure')));
        }

        logger.error(response);
        return response;
      });
  },
  deleteSubmissionTemporaryFile: (surveyId, questionId, fileId) => (dispatch) => {
    dispatch({ type: types.DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE, surveyId, questionId, fileId });
    return api.deleteSubmissionTemporaryFile(surveyId, questionId, fileId)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_SUCCESS, surveyId, questionId, fileId });
        } else {
          dispatch({ type: types.DELETE_SURVEY_SUBMISSION_TEMPORARY_FILE_FAILURE, surveyId, questionId, fileId });
        }
      });
  },
  addComment: (id, data) => dispatch => {
    return api
      .addComment(id, data)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess('Twój komentarz został dodany'));
          window.location.reload();
        } else {
          dispatch(notificationActions.showError(`Dodanie komentarza nie powidło się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },

  startPhoneNumberVerification: ( phoneNumber, verificationMethodId) => (dispatch, getState) => {
    const state = getState();
    return api
      .startPhoneNumberVerification(state.publicSurveyDetails.data.id, phoneNumber, verificationMethodId)
      .then(r => {
        if (r.ok) return { error: null, token: r.data.token };
        if (!r.ok && r.data && r.data.message === 'Already voted') return { error: { alreadyVoted: true } };
        dispatch(notificationActions.showError('Rozpoczęcie weryfikacji numeru telefonu nie powiodło się.'));
        return { error: { other: true } };
      })
      .catch(() => {
        dispatch(notificationActions.showError('Rozpoczęcie weryfikacji numeru telefonu nie powiodło się.'));
        return { error: { other: true } };
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/publicSurveyActions.js